import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: 'Do you offer commercial glass repair near me?',
    a: 'Kosin’s Glass serves commercial glass clients throughout Howell, Ann Arbor, Novi and Southeast Michigan. Request a commercial estimate and the team will confirm availability for your building, project type and location.'
  }, {
    q: 'Do you replace storefront glass?',
    a: 'Yes. Kosin’s Glass provides storefront glass repair, storefront glass replacement, commercial entrances, sidelights, commercial door glass and complete storefront systems.'
  }, {
    q: 'Do you install office glass walls?',
    a: 'Yes. Kosin’s Glass installs office glass walls, dividers, interior partitions, conference room glass, half walls and other interior commercial glass systems.'
  }, {
    q: 'What is contract glazing?',
    a: 'Contract glazing is commercial glass work for construction, renovation and building projects. It can include storefront systems, curtain walls, commercial windows, doors, entrances, interior glass walls, hardware, fabrication and installation.'
  }, {
    q: 'Can you work with builders and general contractors?',
    a: 'Yes. Kosin’s Glass works with builders, contractors, property managers and building owners on commercial glass repair, replacement, fabrication, installation and contract glazing projects.'
  }, {
    q: 'Can you repair commercial glass doors?',
    a: 'Yes. Kosin’s Glass can help with commercial door glass replacement, entry door glass, sidelights, and commercial door parts repair or replacement.'
  }, {
    q: 'Do you service existing commercial buildings?',
    a: 'Yes. Kosin’s Glass provides repair, replacement, system maintenance and glass service for existing storefronts, office buildings, retail spaces and other commercial properties.'
  }, {
    q: 'Do you handle projects outside Southeast Michigan?',
    a: 'Kosin’s Glass primarily serves Southeast Michigan and Michigan. Select larger commercial glazing projects may be available outside Michigan depending on scope, schedule and project requirements.'
  }, {
    q: 'What do you need for a commercial glass quote?',
    a: 'Helpful details include your company name, project address, photos, rough dimensions, drawings or plans, glass type, desired timeline and any bid requirements. Kosin’s Glass will confirm exact needs when they contact you.'
  }];
  return <section className="py-20 bg-white border-t border-slate-200" data-id="element-45">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-46">
        <div className="text-center mb-12" data-id="element-47">
          <h2 className="kosins-heading text-4xl md:text-5xl text-neutral-900" data-id="element-48">
            Commercial Glass Questions
          </h2>
        </div>

        <div className="space-y-4" data-id="element-49">
          {faqs.map((faq, idx) => {
          const isOpen = openIndex === idx;
          return <div key={idx} className={`border rounded-xl overflow-hidden transition-colors ${isOpen ? 'border-primary-200 bg-primary-50/50' : 'border-slate-200 bg-white'}`} data-id="element-50">
                <button onClick={() => setOpenIndex(isOpen ? null : idx)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500" aria-expanded={isOpen} data-id="element-51">
                  <span className="text-lg font-semibold text-navy-900 pr-8" data-id="element-52">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-slate-400 shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180 text-primary-600' : ''}`} data-id="element-53" />
                </button>
                <AnimatePresence initial={false} data-id="element-54">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-55">
                      <div className="px-6 pb-5 text-slate-600 leading-relaxed" data-id="element-56">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}